import React from 'react';
import {
  Box,
  Container,
  Typography,
  useTheme,
} from '@mui/material';
import AnimatedElement from './AnimatedElement';

const AboutSection = () => {
  const theme = useTheme();

  return (
    <Box
      id="about"
      sx={{
        py: { xs: 8, md: 12 },
        bgcolor: 'primary.white'
      }}
    >
      <Container 
        maxWidth={false} 
        sx={{ 
          maxWidth: '1400px',
          pl: { xs: 2, md: 14 }, // 80px = 10 * 8px (theme spacing)
          pr: 2,
          mx: 'auto',
          mb: 8
        }}
      >
         <AnimatedElement>
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: { xs: '1fr', md: '3fr 7fr 1fr' },
            gap: 2,
            alignItems: 'start'
          }}
        >
          {/* Spalte 1: Sektionsüberschrift */}
          
          <Box>
            <Typography
              variant="h2"
              component="h2"
              sx={{
                 fontSize: { xs: '1.6rem', sm: '1.8rem', md: '2.1rem' },
                fontWeight: 500,
                color: '#000',
                lineHeight: 1.2,
                textAlign: 'left'
              }}
            >
              CORPS<br/>
              GUESTPHALIA<br/>
              BERLIN
            </Typography>
            <Box 
              sx={{
                height: '4px', 
                width: '100px', 
                backgroundColor: 'rgb(58, 123, 62)', 
                marginTop: { xs: '20px', sm: '30px', md: '40px' },
                marginBottom: '20px'
              }}
            />
          </Box>

          {/* Spalte 2: Zweispaltiger Fließtext */}
          <Box>
            <Typography
              variant="body1"
              sx={{
                fontSize: { xs: '1rem', md: '1.1rem' },
                lineHeight: 1.6,
                color: '#000',
                textAlign: 'left',
                columnCount: { xs: 1, md: 2 },
                columnGap: '2rem',
                margin: 0,
                '& p': {
                  breakInside: 'avoid',
                  pageBreakInside: 'avoid', // Fallback
                  marginTop: 0, // Entfernt Abstand über dem ersten Absatz
                  marginBottom: 2 // Abstand zwischen Absätzen
                },
                '& p:first-of-type': {
                  marginTop: 0 // Explizit für den ersten Absatz
                },
                columnRule: 'none',
                 marginLeft: { xs: '40px', md: 0 }
              }}
            >
              <p>Das Corps Guestphalia Berlin ist eine studentische Verbindung im grünen Dahlem auf dem Campus der Freien Unversität Berlin. Seit 1845 stehen wir für lebenslange Freundschaft, persönliche Entwicklung und ein aktives Miteinander über Generationen hinweg. Unser Corpsleben verbindet akademischen Anspruch, Geselligkeit, Tradition und Offenheit — auf dem Haus, im Studium und weit darüber hinaus.</p>
              <p>Als Corps verstehen wir uns als weltoffene Gemeinschaft, die auf Toleranz, gegenseitigem Respekt, demokratischen Prinzipien und persönlicher Verantwortung gründet. Wir sind weder konfessionell noch parteipolitisch gebunden; auch ethnische Herkunft oder sexuelle Orientierung sind für uns ohne Belang. Uns verbindet nicht Gleichförmigkeit, sondern die Überzeugung, dass Freundschaft, Charakter und offener Austausch gerade dort wachsen, wo Menschen mit unterschiedlichen Hintergründen einander auf Augenhöhe begegnen.</p>
            </Typography>
          </Box>

          {/* Spalte 3: Gedrehter Text "CORPS" */}
          <Box
            sx={{
              display: { xs: 'none', md: 'flex' },
              justifyContent: 'center',
              alignItems: 'flex-start',
              height: '100%',
              minHeight: { xs: '100px', md: '400px' }
            }}
          >
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '10px' }}>
                            <div style={{ height: '100px', width: '2px', backgroundColor: '#3a7b3e', marginLeft: '-4px' }}></div>
                            <Typography
                              variant="h3"
                              sx={{
                                fontSize: { xs: '0.8rem', md: '0.9rem' },
                                fontWeight: 500,
                                color: '#000',
                                writingMode: { xs: 'horizontal-tb', md: 'vertical-rl' },
                                textOrientation: { md: 'mixed' },
                                whiteSpace: 'nowrap',
                                letterSpacing: '0.2em',
                                textAlign: 'center',
                              }}
                            >
                              CORPS
                            </Typography>
                          </div>
            
          </Box>
        
        </Box>
          </AnimatedElement>
      </Container>
    </Box>
  );
};

export default AboutSection;